import config from '~/config';
import utils from '~/utils';
import { date as commonDateTransform } from '~/network/mainClient/common/transforms/responses';

/**
 * @param {UserShare} data - The user share data to be processed.
 */
export const userSharesItem = (data) => {
    const investments = parseFloat(data.amount) || 0;
    const dividends = parseFloat(data.dividends_summary) || 0;
    const income = data.total_income || 0;
    const currency = '₽';
    const result = {
        id: data.id,
        title: (data.share.estate && data.share.estate.name) || 'Название объекта',
        image: (data.share.estate && data.share.estate.image) || '',
        currency,
        investments,
        dividends,
        income,
        irr: data.irr_income ? (data.irr_income * 100).toFixed(1) : 0,
        irrFormatted: ((data.irr_income && (data.irr_income > 0.0001 || data.irr_income < -0.0001)) ? (data.irr_income * 100).toFixed(1) : 0) + '%',
        mm: data.mm_income || 0,
        share: data.portfolio_share ? (data.portfolio_share * 100).toFixed(1) : 0,
        shareFormatted: (data.portfolio_share ? (data.portfolio_share * 100).toFixed(1) : 0) + '%',
        quantity: data.quantity,
        quantityFormatted: utils.formats.formatNumberWithSpaces(data.quantity),
        investmentsFormatted: utils.formats.formatNumberWithSpaces(investments?.toFixed(0)) + ' ' + currency,
        dividendsFormatted: utils.formats.formatNumberWithSpaces(dividends?.toFixed(0)) + ' ' + currency,
        incomeFormatted: utils.formats.formatNumberWithSpaces(income?.toFixed(0)) + ' ' + currency,
        shareData: data.share,
        avgSharePurchasePrice: data.avg_share_purchase_price || 0,
        avgSharePurchasePriceFormatted: utils.formats.formatNumberWithSpaces(data.avg_share_purchase_price?.toFixed(0) || 0) + ' ' + currency,
        valueGrowthUnrealized: data.value_growth_unrealized || 0,
        valueGrowthUnrealizedFormatted: utils.formats.formatNumberWithSpaces(data.value_growth_unrealized?.toFixed(0) || 0) + ' ' + currency,
        quarterlyReports: data.share.estate ? data.share.estate.quarterly_reports : [],
        currentValue: data.current_value || 0,
        currentValueFormatted: utils.formats.formatNumberWithSpaces(data.current_value?.toFixed(0) || 0) + ' ' + currency,
        trade_sale_profit: data.trade_sale_profit || 0,
        tradeSaleProfitFormatted: utils.formats.formatNumberWithSpaces(data.trade_sale_profit?.toFixed(0) || 0) + ' ' + currency,
    };
    if (result.shareData) {
        result.marketPrice = parseFloat(result.shareData.price);
        result.marketPriceFormatted = utils.formats.formatNumberWithSpaces(result.marketPrice?.toFixed(0) || 0) + ' ' + currency;
    }
    result.estate = {
        title: result.title,
        id: -1,
        ...data.share.estate,
    };
    return result;
};

export const userSharesList = (data) => {
    const result = {
        items: data.results.map(userSharesItem),
        paging: {
            count: data.count || 0,
            page: data.page || 1,
        },
        ...data,
    };
    return result;
};

export const userInvestmentsItem = (data) => {
    const investments = parseFloat(data.amount) || 0;
    const dividends = data.dividends || 0;
    const income = data.pure_income || 0;
    const currency = '₽';
    const result = {
        id: data.id || -1,
        title: (data.estate && data.estate.name) || 'Название объекта',
        image: (data.estate && data.estate.image) || '',
        currency,
        investments,
        dividends,
        income,
        irr: data.irr_income ? (data.irr_income * 100).toFixed(1) : 0,
        mm: data.mm_income || 0,
        share: data.portfolio_share ? (data.portfolio_share * 100).toFixed(1) : 0,
        investmentsFormatted: utils.formats.formatNumberWithSpaces(investments) + ' ' + currency,
        dividendsFormatted: utils.formats.formatNumberWithSpaces(dividends) + ' ' + currency,
        incomeFormatted: utils.formats.formatNumberWithSpaces(income) + ' ' + currency,
        status: data.status || 'new',
        round: data.investment_round || 0,
    };
    const estate = {
        title: result.title,
        id: -1,
        ...data.estate,
    };
    result.estate = estate;
    return result;
};

export const userInvestmentsList = (data) => {
    const result = {
        items: data.results.map(userInvestmentsItem),
        paging: {
            count: data.count || 0,
            page: data.page || 1,
        },
        ...data,
    };
    return result;
};

export const request = (data) => {
    let statusFormatted = 'Идет сбор средств'; // if status === 'new', default
    // if (data.is_status_form_required) {
    // eslint-disable-next-line no-constant-condition
    if (false) {
        statusFormatted = 'STATUS_FORM_REQUIRED';
    } else if (data.status === 'wait_sign') {
        statusFormatted = 'Требует подписи';
    } else if (data.status === 'signed') {
        statusFormatted = 'Подписана';
    } else if (data.status === 'completed') {
        statusFormatted = 'Проведена';
    }
    const price = parseFloat(data.price);
    const sum = price * data.quantity;
    const result = {
        id: data.id,
        amount: parseFloat(data.amount),
        amountFormatted: utils.formats.formatNumberWithSpaces(parseFloat(data.amount)) + ' ₽',
        current: data.estate.balance,
        image: data.estate.image,
        status: data.status,
        statusFormatted,
        date: commonDateTransform(data.created),
        quantity: data.quantity,
        price,
        priceFormatted: utils.formats.formatNumberWithSpaces(price) + ' ₽',
        sum,
        sumFormatted: utils.formats.formatNumberWithSpaces(sum) + ' ₽',
        documents: data.documents || [],
        isStatusFormRequired: !!data.is_status_form_required,
        target: data.estate.target,
        title: data.estate.name,
        url: `${config.urls.estates.item}${data.estate.id}/`,
        round: data.investment_round || 0,
        estate: {
            id: data.estate.id,
            url: data.estate.url,
            title: data.estate.name,
            image: data.estate.image,
        },
    };
    return result;
};

export const requestsList = (data) => {
    const result = {
        items: data.results.map(request),
        paging: {
            count: data.count || 0,
            page: data.page || 1,
        },
        ...data,
    };
    return result;
};
